module.exports = __webpack_public_path__ + "img/attack_electrik.7c6f9795.png";